import { Button } from 'primereact/button'

import { VatRecordDto } from '../../../_generated/api/user-management'
import { Column, Row } from './FlexContainer'
import { TextField } from './input-fields'
import { pi } from './PrimeIcon'
import Organization from '../../../models/Organization'
import { formatVAT } from '../../../tools/format'
import t from '../../../tools/t'

interface OrganizationAssociationListProps {
    associations: VatRecordDto[]
    setAssociations: (records: VatRecordDto[]) => void
    disabled?: boolean
}

export default function OrganizationAssociationList({
    associations,
    setAssociations,
    disabled,
}: OrganizationAssociationListProps) {
    const addRecord = () => {
        if (disabled) return
        setAssociations([...associations, Organization.getEmptyVatRecord()])
    }

    const updateRecord = (index: number, name?: string, value?: string) => {
        if (disabled) return
        const editing = associations[index]
        editing.name = name
        editing.vatNo = value
        setAssociations([...associations])
    }

    const deleteRecord = (index: number) => {
        if (disabled) return
        const updated = [...associations]
        updated.splice(index, 1)
        setAssociations(updated)
    }

    return (
        <Column gap={1} alignment="start">
            {associations.map((record, i) => (
                <Row
                    key={i}
                    className="input-group input-group--association-distribution"
                    alignment="center"
                    wide
                >
                    <TextField
                        placeholder={t('organization_field_association_number')}
                        value={formatVAT(record.vatNo) ?? ''}
                        disabled={disabled}
                        onChange={(e) =>
                            updateRecord(i, record.name ?? undefined, formatVAT(e.target.value))
                        }
                    />
                    <TextField
                        placeholder={t('organization_field_association_name')}
                        value={record.name}
                        disabled={disabled}
                        onChange={(e) => updateRecord(i, e.target.value, record.vatNo ?? undefined)}
                    />
                    {associations.length > 1 && (
                        <Button
                            onClick={() => deleteRecord(i)}
                            className="input-group__action"
                            icon={pi('times')}
                            severity="danger"
                            text
                            disabled={disabled}
                        />
                    )}
                </Row>
            ))}
            <Button
                label={t('common_add_another')}
                icon={pi('plus')}
                onClick={addRecord}
                severity="secondary"
                text
                disabled={disabled}
            />
        </Column>
    )
}
